export const FLETCHERS_ORG_NAME = 'Fletchers';
export const MLS_ORG_NAME = 'MLS';

// Orgs (by `debug/list-orgs` name) whose expired cases must never be purged
// from the Global Admin Dashboard.
export const PURGE_PROTECTED_ORG_NAMES: readonly string[] = [FLETCHERS_ORG_NAME, MLS_ORG_NAME];
